export const SET_TICKET_STATES = "SET_TICKET_STATES";
export const SET_TICKET_STATES_MAP = "SET_TICKET_STATES_MAP";
export const ADD_TICKET_STATE = "ADD_TICKET_STATE";
export const UPDATE_TICKET_STATE = "UPDATE_TICKET_STATE";
export const REMOVE_TICKET_STATE = "REMOVE_TICKET_STATE";
export const SET_ORDER_STATES = "SET_ORDER_STATES";
export const SET_ORDER_STATES_MAP = "SET_ORDER_STATES_MAP";
